'use client';

import { useRef } from 'react';

import CalendarSearch from '@/components/calendar/calendar-search';
import EventCardsMobile from '@/components/event-cards/event-cards-mobile';
import { useWindowDimensions } from '@/hooks/use-window-dimensions';
import { WithLang } from '@/types/general';
import { screenBreakpoints } from '@/utils/constants';

import useEventCards from '../event-cards/use-event-cards';
import CalendarFiltersDesktop from './calendar-filters.desktop';
import CalendarFiltersMobile from './calendar-filters.mobile';
import CalendarRuler from './calendar-ruler';
import { useCalendar } from './use-calendar';
import { useFilters } from './use-filters';

export default function CalendarMobile(props: WithLang) {
    const { dimensions } = useWindowDimensions();

    const { selectedDays, handleSelectRange, todayHandler } = useCalendar();

    const {
        filtersAvailable,
        filtersSelected,
        filtersSelectedCount,
        handleAddFilter,
        handleRemoveFilter,
        handleResetFilters,
    } = useFilters();

    const {
        notFoundContext,
        events,
        toggleSearchRangeOff,
        toggleSearchRangeOn,
        onSearchSubmit,
        onSearchChange,
        onSearchClear,
        sortByDate,
        sortByScore,
        searchArgs,
        withSearch,
        loading,
    } = useEventCards();

    const eventsDivRef = useRef<HTMLDivElement>(null);

    return (
        <>
            <CalendarSearch
                onSearchClear={onSearchClear}
                selectedDays={selectedDays}
                events={events}
                toggleSearchRangeOff={toggleSearchRangeOff}
                toggleSearchRangeOn={toggleSearchRangeOn}
                onSearchChange={onSearchChange}
                sortByScore={sortByScore}
                sortByDate={sortByDate}
                onSearchSubmit={onSearchSubmit}
                searchArgs={searchArgs}
                lang={props.lang}
            />
            {dimensions.width >= screenBreakpoints.sm ? (
                <CalendarFiltersDesktop
                    filtersAvailable={filtersAvailable}
                    filtersSelected={filtersSelected}
                    filtersSelectedCount={filtersSelectedCount}
                    handleAddFilter={handleAddFilter}
                    handleRemoveFilter={handleRemoveFilter}
                    onReset={handleResetFilters}
                    lang={props.lang}
                />
            ) : (
                <CalendarFiltersMobile
                    filtersAvailable={filtersAvailable}
                    filtersSelected={filtersSelected}
                    filtersSelectedCount={filtersSelectedCount}
                    handleAddFilter={handleAddFilter}
                    handleRemoveFilter={handleRemoveFilter}
                    onReset={handleResetFilters}
                    lang={props.lang}
                />
            )}
            <div className="relative grid grid-cols-1 gap-x-4">
                <CalendarRuler
                    isHidden={Boolean(searchArgs.searchString) && !Boolean(searchArgs.ranged)}
                    selectedDays={selectedDays}
                    lang={props.lang}
                    onSelectDays={handleSelectRange}
                    todayHandler={todayHandler}
                />
                <div ref={eventsDivRef} className="mt-5 pb-5 xs:pb-0">
                    <EventCardsMobile
                        withDates={!withSearch || !Boolean(searchArgs.sortByScore)}
                        events={events}
                        isLoading={loading}
                        notFoundContext={notFoundContext}
                        lang={props.lang}
                    />
                </div>
            </div>
        </>
    );
}
